var map = {
	"./dashboard/ai-load.gif": 9913,
	"./dashboard/fileNode.svg": 2116,
	"./dashboard/ocrNode.svg": 5223,
	"./dashboard/odNode.svg": 460,
	"./dashboard/outNode.svg": 2693,
	"./dashboard/tableNode.svg": 2810,
	"./dashboard/treeNode.svg": 2825,
	"./dashboard/upcloud.svg": 8739,
	"./initialPage/bkg.svg": 7968,
	"./initialPage/connection.svg": 7246,
	"./initialPage/exit.svg": 9172,
	"./initialPage/home.svg": 9441,
	"./initialPage/mngProj.svg": 2976,
	"./initialPage/newAi.png": 5027,
	"./initialPage/newAi.svg": 6245,
	"./initialPage/painter.svg": 1631,
	"./initialPage/recommendations.svg": 8604,
	"./login/github.svg": 9129,
	"./logo.png": 6949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;